import React from 'react';
import { fetchClassesOptions } from '../../../services/options_services';
import InputSelectAsync from '../InputSelectAsync';

const ClassInputAsync = (props) => {
  return (
    <InputSelectAsync
      loadOptions={(search) => fetchClassesOptions({ search })}
      getOptionValue={(d) => d.id}
      getOptionLabel={(d) => d.nome}
      key={props.key}
      {...props}
    />
  );
};
export default ClassInputAsync;
